export default __webpack_public_path__ + "static/media/Eye_1_M_C2.e730d844.svg";